import { render, staticRenderFns } from "./PdfarlIndextab12.vue?vue&type=template&id=0e868060"
import script from "./PdfarlIndextab12.vue?vue&type=script&lang=js"
export * from "./PdfarlIndextab12.vue?vue&type=script&lang=js"
import style0 from "./PdfarlIndextab12.vue?vue&type=style&index=0&id=0e868060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports